import React, { useEffect, useState } from "react";
import { TextArea } from "./components/TextArea";
import Heading from "../../components/Heading";
import InputField from "../../components/Forms/InputField";
import { getAmbassadorDetails, updateAmbassador } from "../../api/users";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ImageInput from "../../components/Forms/ImageInput";
import { useLocation } from "react-router-dom";

const GreenAmbassadorEdit = () => {

    const { state } = useLocation();

    const [personalFields, setPersonalFields] = useState([
        { label: 'First Name', type: 'text', placeholder: 'Enter First Name', name: 'firstName', value: '', required: true },
        { label: 'Last Name', type: 'text', placeholder: 'Enter Last Name', name: 'lastName', value: '', required: true },
        { label: 'User Name', type: 'text', placeholder: 'Enter User Name', name: 'username', value: '', required: true },
        { label: 'Email', type: 'email', placeholder: 'Enter Email', name: 'email', value: '', required: true },
        { label: 'Mobile Number', type: 'tel', placeholder: 'Enter Mobile Number', name: 'mobile', value: '', required: true },
        { label: 'Gender', type: 'select', placeholder: 'Choose Gender', name: 'gender', value: '', required: true, data: [
            { value: 'male', placeholder: 'Male' },
            { value: 'female', placeholder: 'Female' },
            { value: 'other', placeholder: 'Other' },
        ]},
        { label: 'Affiliation Code', type: 'text', placeholder: 'Enter Affiliation Code', name: 'affiliationCode', value: '' },
        { label: 'Influencer', type: 'checkbox', name: 'isInfluencer', value: false },
    ]);

    const [locationFields, setLocationFields] = useState([
        { label: 'Country', type: 'text', placeholder: 'Enter Country', name: 'country', value: '' },
        { label: 'State', type: 'text', placeholder: 'Enter State', name: 'state', value: '' },
        { label: 'City', placeholder: 'Enter City', name: 'city', value: '' },
        { label: 'Address', placeholder: 'Enter Address', name: 'address', value: '' },
        { label: 'Pincode', placeholder: 'Enter Pincode', name: 'pincode', value: '' },
        { label: 'Landmark', placeholder: 'Enter Nearest Landmark', name: 'landmark', value: '' }
    ]);

    const [socialFields, setSocialFields] = useState([
        { label: 'LinkedIn', placeholder: 'https://linkedin.com/in/username', name: 'linkedIn', value: '', type: 'url' },
        { label: 'Instagram', placeholder: 'https://instagram.com/username', name: 'instagram', value: '', type: 'url' },
        { label: 'Facebook', placeholder: 'https://facebook.com/username', name: 'facebook', value: '', type: 'url' },
        { label: 'Twitter', placeholder: 'https://twitter.com/username', name: 'twitter', value: '', type: 'url' }
    ]);

    const [contactPersonFields, setContactPersonFields] = useState([
        { label: 'Contact Person Name', type: 'text', placeholder: 'Enter Contact Person Name', name: 'contactPersonName', value: '' },
        { label: 'Contact Person Email', type: 'email', placeholder: 'Enter Contact Person Email', name: 'contactPersonEmail', value: '' },
        { label: 'Contact Person Phone', type: 'tel', placeholder: 'Enter Contact Person Phone', name: 'contactPersonPhone', value: '' }
    ]);

    const [ambassadorDetails, setAmbassadorDetails] = useState([
        { label: 'About', type: 'textarea', placeholder: 'Tell us about yourself...', name: 'about', value: '' },
        { label: 'Why do you want to be an ambassador?', type: 'textarea', placeholder: 'Explain why you want to be an ambassador...', name: 'whyAmbassador', value: '' },
        { label: 'Experience', type: 'text', placeholder: 'Enter your experience', name: 'experience', value: '' },
        { label: 'Goals', type: 'textarea', placeholder: 'What are your goals as an ambassador?', name: 'goals', value: '' },
        { label: 'Skills', type: 'text', placeholder: 'Enter your skills', name: 'skills', value: '' },
        { label: 'Availability', type: 'text', placeholder: 'Enter your availability', name: 'availability', value: '' }
    ]);

    const [auditTrail, setAuditTrail] = useState('');

    const handlePersonalFieldChange = (index, newValue) => {
        setPersonalFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };

    const handleSocialFieldChange = (index, newValue) => {
        setSocialFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };

    const handleLocationFieldChange = (index, newValue) => {
        setSocialFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };

    const handleAmbassadorDetailsChange = (index, newValue) => {
        setAmbassadorDetails(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };

    const [active, setActive] = useState(true);
    const [image, setImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    
    // Helper function to validate URLs
    const isValidUrl = (url) => {
        try {
            new URL(url);
            return true;
        } catch (e) {
            return false;
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();
        
        // Basic form validation
        const requiredFields = personalFields.filter(field => field.required);
        for (const field of requiredFields) {
            if (!field.value) {
                toast.error(`${field.label} is required`);
                return;
            }
        }

        // URL validation for social fields
        const urlFields = socialFields;
        for (const field of urlFields) {
            if (field.value && !isValidUrl(field.value)) {
                toast.error(`Please enter a valid URL for ${field.label}`);
                return;
            }
        }

        const formData = new FormData();
        
        // Add personal fields
        personalFields.forEach(field => {
            formData.append(field.name, field.value);
        });

        // Add location fields
        locationFields.forEach(field => {
            formData.append(field.name, field.value);
        });

        // Add social fields
        socialFields.forEach(field => {
            formData.append(`social.${field.name}`, field.value);
        });

        // Add contact person details
        contactPersonFields.forEach(field => {
            formData.append(`contactPerson.${field.name}`, field.value);
        });

        // Add audit trail
        if (auditTrail) {
            formData.append('auditTrail', auditTrail);
        }

        // Add profile image if present
        if (image) {
            formData.append('profileImage', image);
        }

        try {
            const formData = {
                active: active,
                firstName: personalFields[0]?.value || '',
                middleName: personalFields[1]?.value || '',
                lastName: personalFields[2]?.value || '',
                username: personalFields[3]?.value || '',
                displayName: personalFields[4]?.value || '',
                email: personalFields[5]?.value || '',
                mobile: personalFields[7]?.value || '',
                dob: personalFields[8]?.value || '',
                gender: personalFields[9]?.value || '',
                country: locationFields[0]?.value || '',
                state: locationFields[1]?.value || '',
                city: locationFields[2]?.value || '',
                address: locationFields[3]?.value || '',
                pincode: locationFields[4]?.value || '',
                landmark: locationFields[5]?.value || '',
                linkedIn: socialFields[0]?.value || '',
                instagram: socialFields[1]?.value || '',
                facebook: socialFields[2]?.value || '',
                twitter: socialFields[3]?.value || '',
                youtube: socialFields[4]?.value || '',
                website: socialFields[5]?.value || '',
                message: ambassadorDetails[0]?.value || '',
                about: ambassadorDetails[1]?.value || '',
                postTitle: ambassadorDetails[2]?.value || '',
                postContent: ambassadorDetails[3]?.value || '',
                btnTitle: ambassadorDetails[4]?.value || '',
                btnUrl: ambassadorDetails[5]?.value || '',
                postActivationDate: ambassadorDetails[6]?.value || '',
                postExpiryDate: ambassadorDetails[7]?.value || '',
                isImagePresent: image?.type ? true : false
            };
            
            const response = await updateAmbassador(state?.userId, formData, toast);
            if (response) {
                toast.success('Ambassador updated successfully');
                // Navigate back or refresh data
            }
        } catch (error) {
            console.error('Error updating ambassador:', error);
            toast.error('Failed to update ambassador');
        }
        };

    useEffect(() => {
        getAmbassadorDetails(state._id, personalFields, setPersonalFields, socialFields, setSocialFields, locationFields, setLocationFields, ambassadorDetails, setAmbassadorDetails, setImage, setActive, toast);
        // eslint-disable-next-line
    }, []);

    return (
        <form className="flex flex-col font-semibold">
            <div className="flex justify-between">
                <Heading
                    text={"Update Green Ambassador Form"}
                />
                <div className="flex justify-between items-center">
                    <label className="inline-flex items-center me-5 cursor-pointer">
                        <span className="ms-3 text-base font-medium text-gray-900 dark:text-gray-300 mr-2">Inactive</span>
                        <input type="checkbox" name={'active'} value={active} className="sr-only peer" onChange={() => setActive(!active)} checked={active} />
                        <div className="relative w-11 h-6 bg-white border-black ring-1 ring-secondary rounded-full peer dark:bg-white peer-focus:ring-primary dark:peer-focus:ring-primary peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-secondary after:border-secondary peer-checked:after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                        <span className="ms-3 text-base font-medium text-gray-900 dark:text-gray-300">Active</span>
                    </label>
                </div>
            </div>

            <section className="flex flex-col justify-center px-5 py-9 mt-2 w-full bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)]">
                <div className="flex flex-col max-w-full w-[1084px]">
                    <div className="flex flex-wrap gap-6 justify-between items-center w-full">
                        <div className="flex flex-col self-stretch my-auto text-sm min-w-[240px] w-[880px]">
                            <div className="flex flex-wrap gap-3 items-center w-full">
                                {/* First Name */}
                                <InputField
                                    label={personalFields[0].label}
                                    name={personalFields[0].name}
                                    value={personalFields[0].value}
                                    placeholder={personalFields[0].placeholder}
                                    type={personalFields[0].type}
                                    required={personalFields[0].required}
                                    onChange={e => handlePersonalFieldChange(0, e.target.value)}
                                />
                                {/* Middle Name */}
                                <InputField
                                    label={personalFields[1].label}
                                    name={personalFields[1].name}
                                    value={personalFields[1].value}
                                    placeholder={personalFields[1].placeholder}
                                    type={personalFields[1].type}
                                    required={personalFields[1].required}
                                    onChange={e => handlePersonalFieldChange(1, e.target.value)}
                                />
                                {/* Last Name */}
                                <InputField
                                    label={personalFields[2].label}
                                    name={personalFields[2].name}
                                    value={personalFields[2].value}
                                    placeholder={personalFields[2].placeholder}
                                    type={personalFields[2].type}
                                    required={personalFields[2].required}
                                    onChange={e => handlePersonalFieldChange(2, e.target.value)}
                                />
                            </div>

                            <div className="flex flex-wrap gap-3 items-center w-full">
                                {/* Username */}
                                <InputField
                                    label={personalFields[3].label}
                                    name={personalFields[3].name}
                                    value={personalFields[3].value}
                                    placeholder={personalFields[3].placeholder}
                                    type={personalFields[3].type}
                                    required={personalFields[3].required}
                                    onChange={e => handlePersonalFieldChange(3, e.target.value)}
                                />
                                {/* Display Name */}
                                <InputField
                                    label={personalFields[4].label}
                                    name={personalFields[4].name}
                                    value={personalFields[4].value}
                                    placeholder={personalFields[4].placeholder}
                                    type={personalFields[4].type}
                                    required={personalFields[4].required}
                                    onChange={e => handlePersonalFieldChange(4, e.target.value)}
                                />
                            </div>

                            <div className="flex flex-wrap gap-3 items-end w-full">
                                {/* Email */}
                                <InputField
                                    label={personalFields[5].label}
                                    name={personalFields[5].name}
                                    value={personalFields[5].value}
                                    placeholder={personalFields[5].placeholder}
                                    type={personalFields[5].type}
                                    required={personalFields[5].required}
                                    onChange={e => handlePersonalFieldChange(5, e.target.value)}
                                />
                                {/* Password */}
                                <InputField
                                    label={personalFields[6].label}
                                    name={personalFields[6].name}
                                    value={personalFields[6].value}
                                    placeholder={personalFields[6].placeholder}
                                    type={personalFields[6].type}
                                    required={personalFields[6].required}
                                    onChange={e => handlePersonalFieldChange(6, e.target.value)}
                                    disabled={true}
                                />
                                <button className="overflow-hidden gap-2.5 px-4 py-3 text-center rounded-md bg-navBtn h-min text-zinc-600 justify-end place-self-end">
                                    Generate Password
                                </button>
                            </div>
                        </div>

                        {/* Profile Picture Section */}
                        <ImageInput
                            image={image}
                            setImage={setImage}
                            text={'Profile Picture'}
                        />
                    </div>

                    {/* Contact Information */}
                    <div className="flex flex-wrap gap-3 items-center  w-full text-sm">
                        <div className="flex flex-col flex-1 shrink basis-0 min-w-[240px]">
                            {/* Mobile Number */}
                            <InputField
                                label={personalFields[7].label}
                                name={personalFields[7].name}
                                value={personalFields[7].value}
                                placeholder={personalFields[7].placeholder}
                                type={personalFields[7].type}
                                required={personalFields[7].required}
                                onChange={e => handlePersonalFieldChange(7, e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col flex-1 shrink basis-0 min-w-[240px]">
                            {/* Date Of Birth */}
                            <InputField
                                label={personalFields[8].label}
                                name={personalFields[8].name}
                                value={personalFields[8].value ? new Date(personalFields[8].value).toISOString().split("T")[0] : ''}
                                placeholder={personalFields[8].placeholder}
                                type={personalFields[8].type}
                                required={personalFields[8].required}
                                onChange={e => handlePersonalFieldChange(8, e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="">
                        {/* User Type */}
                        <InputField
                            label={personalFields[9].label}
                            name={personalFields[9].name}
                            value={personalFields[9].value}
                            placeholder={personalFields[9].placeholder}
                            type={personalFields[9].type}
                            required={personalFields[9].required}
                            onChange={e => handlePersonalFieldChange(9, e.target.value)}
                            data={personalFields[9].data}
                        />
                    </div>

                    <div className="flex flex-wrap gap-3  w-full text-sm">
                        {/* Country */}
                        <InputField
                            label={locationFields[0].label}
                            name={locationFields[0].name}
                            value={locationFields[0].value}
                            placeholder={locationFields[0].placeholder}
                            type={locationFields[0].type}
                            required={locationFields[0].required}
                            onChange={e => handleLocationFieldChange(10, e.target.value)}
                            data={locationFields[0].data}
                        />
                        {/* State */}
                        <InputField
                            label={locationFields[1].label}
                            name={locationFields[1].name}
                            value={locationFields[1].value}
                            placeholder={locationFields[1].placeholder}
                            type={locationFields[1].type}
                            required={locationFields[1].required}
                            onChange={e => handleLocationFieldChange(1, e.target.value)}
                            data={locationFields[1].data}
                        />
                    </div>
                    <div className="">
                        {/* City */}
                        <InputField
                            label={locationFields[2].label}
                            name={locationFields[2].name}
                            value={locationFields[2].value}
                            placeholder={locationFields[2].placeholder}
                            type={locationFields[2].type}
                            required={locationFields[2].required}
                            onChange={e => handleLocationFieldChange(2, e.target.value)}
                        />
                    </div>
                    <div className="">
                        {/* Address */}
                        <InputField
                            label={locationFields[3].label}
                            name={locationFields[3].name}
                            value={locationFields[3].value}
                            placeholder={locationFields[3].placeholder}
                            type={locationFields[3].type}
                            required={locationFields[3].required}
                            onChange={e => handleLocationFieldChange(3, e.target.value)}
                        />
                    </div>
                    <div className="">
                        {/* Pincode */}
                        <InputField
                            label={locationFields[4].label}
                            name={locationFields[4].name}
                            value={locationFields[4].value}
                            placeholder={locationFields[4].placeholder}
                            type={locationFields[4].type}
                            required={locationFields[4].required}
                            onChange={e => handleLocationFieldChange(4, e.target.value)}
                        />
                    </div>
                    <div className="">
                        {/* Landmark */}
                        <InputField
                            label={locationFields[5].label}
                            name={locationFields[5].name}
                            value={locationFields[5].value}
                            placeholder={locationFields[5].placeholder}
                            type={locationFields[5].type}
                            required={locationFields[5].required}
                            onChange={e => handleLocationFieldChange(5, e.target.value)}
                        />
                    </div>
                </div>
            </section>

            {/* Social Media Section */}
            <section className="flex flex-col justify-center px-5 py-9 mt-8 w-full text-sm bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)]">
                <div className="flex flex-col w-full max-w-[1084px]">
                    <h2 className="text-lg text-gray-900">Social Media Details</h2>
                    <div className="flex flex-wrap gap-3  w-full">
                        {/* LinkedIn */}
                        <InputField
                            label={socialFields[0].label}
                            name={socialFields[0].name}
                            value={socialFields[0].value}
                            placeholder={socialFields[0].placeholder}
                            type={socialFields[0].type}
                            required={socialFields[0].required}
                            onChange={e => handleSocialFieldChange(0, e.target.value)}
                        />
                        {/* Instagram */}
                        <InputField
                            label={socialFields[1].label}
                            name={socialFields[1].name}
                            value={socialFields[1].value}
                            placeholder={socialFields[1].placeholder}
                            type={socialFields[1].type}
                            required={socialFields[1].required}
                            onChange={e => handleSocialFieldChange(1, e.target.value)}
                        />
                    </div>

                    <div className="flex flex-wrap gap-3  w-full">
                        {/* Facebook */}
                        <InputField
                            label={socialFields[2].label}
                            name={socialFields[2].name}
                            value={socialFields[2].value}
                            placeholder={socialFields[2].placeholder}
                            type={socialFields[2].type}
                            required={socialFields[2].required}
                            onChange={e => handleSocialFieldChange(2, e.target.value)}
                        />
                        {/* Twitter */}
                        <InputField
                            label={socialFields[3].label}
                            name={socialFields[3].name}
                            value={socialFields[3].value}
                            placeholder={socialFields[3].placeholder}
                            type={socialFields[3].type}
                            required={socialFields[3].required}
                            onChange={e => handleSocialFieldChange(3, e.target.value)}
                        />
                    </div>

                    <div className="flex flex-wrap gap-3  w-full">
                        {/* Youtube */}
                        <InputField
                            label={socialFields[4].label}
                            name={socialFields[4].name}
                            value={socialFields[4].value}
                            placeholder={socialFields[4].placeholder}
                            type={socialFields[4].type}
                            required={socialFields[4].required}
                            onChange={e => handleSocialFieldChange(4, e.target.value)}
                        />
                        {/* Website */}
                        <InputField
                            label={socialFields[5].label}
                            name={socialFields[5].name}
                            value={socialFields[5].value}
                            placeholder={socialFields[5].placeholder}
                            type={socialFields[5].type}
                            required={socialFields[5].required}
                            onChange={e => handleSocialFieldChange(5, e.target.value)}
                        />
                    </div>
                </div>
            </section>

            {/* Ambassador Details Section */}
            <section className="flex flex-col px-5 py-9 mt-8 w-full bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)]">
                <div className="flex flex-col w-full">
                    <div className="flex gap-10 items-start w-full max-w-[1087px]">
                        <div className="flex flex-wrap gap-10 items-start min-w-[240px] w-[1087px]">
                            <h2 className="text-lg text-gray-900">Ambassador Details</h2>
                            <div className="flex flex-col grow shrink text-sm text-center text-gray-900 min-w-[240px] w-[437px]">
                                <div className="flex gap-2.5 items-center justify-end">
                                    <button className="overflow-hidden gap-2.5 px-5 py-2.5 rounded-md bg-navBtn">
                                        View Past Posts
                                    </button>
                                    <button className="overflow-hidden gap-2.5 px-5 py-2.5 rounded-md bg-navBtn">
                                        Archive A Post
                                    </button>
                                    <button className="flex overflow-hidden gap-2.5 justify-center items-center py-2.5 px-4 rounded-md bg-navBtn">
                                        <img
                                            loading="lazy"
                                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/4add1b29d90e78283ed735a5fe3ca3db354dd2df3922d9c175b1ba70a6ea1edd?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                                            alt=""
                                            className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                                        />
                                        <span className="self-stretch my-auto w-[93px]">
                                            Add New Post
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <TextArea
                        label={ambassadorDetails[0].label}
                        placeholder={ambassadorDetails[0].placeholder}
                        minHeight="180px"
                        name={ambassadorDetails[0].name}
                        type={ambassadorDetails[0].type}
                        value={ambassadorDetails[0].value}
                        onChange={e => handleAmbassadorDetailsChange(0, e.target.value)}
                    />

                    <TextArea
                        label={ambassadorDetails[1].label}
                        placeholder={ambassadorDetails[1].placeholder}
                        minHeight="180px"
                        name={ambassadorDetails[1].name}
                        type={ambassadorDetails[1].type}
                        value={ambassadorDetails[1].value}
                        onChange={e => handleAmbassadorDetailsChange(1, e.target.value)}
                    />

                    <InputField
                        label={ambassadorDetails[2].label}
                        name={ambassadorDetails[2].name}
                        value={ambassadorDetails[2].value}
                        placeholder={ambassadorDetails[2].placeholder}
                        type={ambassadorDetails[2].type}
                        required={ambassadorDetails[2].required}
                        onChange={e => handleAmbassadorDetailsChange(2, e.target.value)}
                    />

                    <TextArea
                        label={ambassadorDetails[3].label}
                        placeholder={ambassadorDetails[3].placeholder}
                        minHeight="180px"
                        name={ambassadorDetails[3].name}
                        type={ambassadorDetails[3].type}
                        value={ambassadorDetails[3].value}
                        onChange={e => handleAmbassadorDetailsChange(3, e.target.value)}
                    />

                    <div className="flex flex-wrap gap-3  max-w-full text-sm w-[1084px]">
                        <InputField
                            label={ambassadorDetails[4].label}
                            name={ambassadorDetails[4].name}
                            value={ambassadorDetails[4].value}
                            placeholder={ambassadorDetails[4].placeholder}
                            type={ambassadorDetails[4].type}
                            required={ambassadorDetails[4].required}
                            onChange={e => handleAmbassadorDetailsChange(4, e.target.value)}
                        />
                        <InputField
                            label={ambassadorDetails[5].label}
                            name={ambassadorDetails[5].name}
                            value={ambassadorDetails[5].value}
                            placeholder={ambassadorDetails[5].placeholder}
                            type={ambassadorDetails[5].type}
                            required={ambassadorDetails[5].required}
                            onChange={e => handleAmbassadorDetailsChange(5, e.target.value)}
                        />
                    </div>

                    <div className="flex flex-wrap gap-3  max-w-full text-sm w-[1084px]">
                        <InputField
                            label={ambassadorDetails[6].label}
                            name={ambassadorDetails[6].name}
                            value={ambassadorDetails[6].value ? new Date(ambassadorDetails[6].value).toISOString().split("T")[0] : ''}
                            placeholder={ambassadorDetails[6].placeholder}
                            type={ambassadorDetails[6].type}
                            required={ambassadorDetails[6].required}
                            onChange={e => handleAmbassadorDetailsChange(6, e.target.value)}
                        />
                        <InputField
                            label={ambassadorDetails[7].label}
                            name={ambassadorDetails[7].name}
                            value={ambassadorDetails[7].value ? new Date(ambassadorDetails[7].value).toISOString().split("T")[0] : ''}
                            placeholder={ambassadorDetails[7].placeholder}
                            type={ambassadorDetails[7].type}
                            required={ambassadorDetails[7].required}
                            onChange={e => handleAmbassadorDetailsChange(7, e.target.value)}
                        />
                    </div>
                </div>

                <div className="flex flex-wrap gap-10 justify-between items-center mt-12 w-full text-base text-center">
                    <button
                        type="reset"
                        className="overflow-hidden gap-2.5 self-stretch px-5 py-2.5 my-auto rounded-md bg-navBtn text-zinc-600 w-[150px]"
                    >
                        Reset Form
                    </button>
                    <div className="flex gap-3 items-center self-stretch my-auto whitespace-nowrap min-w-[240px]">
                        <button className="overflow-hidden gap-2.5 self-stretch px-5 py-2.5 my-auto text-gray-900 bg-white border-primary rounded-md border-2   border-solid w-[150px]">
                            Cancel
                        </button>
                        <button type="submit" className="overflow-hidden gap-2.5 self-stretch px-5 py-2.5 my-auto text-white font-semibold bg-primary border-primary border-2 rounded-md w-[150px]" onClick={handleSubmit}>
                            Submit
                        </button>
                    </div>
                </div>
            </section>
            <ToastContainer
                position="top-right"
            />
        </form>
    );
};

export default GreenAmbassadorEdit;